export default __webpack_public_path__ + "static/media/eye-open.b79405a2.png";